import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ['close']

  clearFlash() {
    this.element.classList.add('remove')
    setTimeout(() => {
      this.element.remove()
    }, 1000)
  }
}